import PricingCards from '../components/PricingCards';
import SectionHeader from '../components/SectionHeader';
import Seo from '../components/Seo';
import { pageIntros } from '../data/site';

export default function Pricing() {
  return (
    <>
      <Seo
        title="Pricing"
        description="Compare the DropBridge Free, Pro, Business, and Scale plans for importing, syncing, and publishing supplier products to Shopify."
        path="/pricing"
      />
      <section className="pb-8 pt-32">
        <div className="container-page">
          <SectionHeader {...pageIntros.pricing} />
        </div>
      </section>
      <PricingCards showHeader={false} />
    </>
  );
}
